import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class PayrollSettingsDA {
  static apiResponse: ApiResponse

  public static async getSettings(
    id_company: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/settings`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async upsertSettings(
    id_company: string,
    body: any
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/settings`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.put(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }
}
